const JSON_DATE_KEY = '__jsonDate';
const ISO_DATE_PATTERN = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(\.\d{1,3})?Z?$/;

function serializeJson(value: unknown): string {
  return JSON.stringify(value, (_key, item) =>
    item instanceof Date ? { [JSON_DATE_KEY]: item.toISOString() } : item,
  );
}

function reviveLegacyIsoDateStrings(value: unknown): unknown {
  if (value == null || value instanceof Date) {
    return value;
  }
  if (Array.isArray(value)) {
    return value.map(reviveLegacyIsoDateStrings);
  }
  if (typeof value === 'object') {
    return Object.fromEntries(
      Object.entries(value as Record<string, unknown>).map(([key, entry]) => [
        key,
        reviveLegacyIsoDateStrings(entry),
      ]),
    );
  }
  if (typeof value === 'string' && ISO_DATE_PATTERN.test(value)) {
    const date = new Date(value);
    return Number.isNaN(date.getTime()) ? value : date;
  }
  return value;
}

function deserializeJson<T>(item: string): T {
  const parsed = JSON.parse(item, (_key, entry) => {
    if (
      entry &&
      typeof entry === 'object' &&
      JSON_DATE_KEY in entry &&
      typeof entry[JSON_DATE_KEY] === 'string'
    ) {
      return new Date(entry[JSON_DATE_KEY]);
    }
    return entry;
  });

  return reviveLegacyIsoDateStrings(parsed) as T;
}

export { deserializeJson, serializeJson };
